import { useApi } from './api';

export const useMatchDetails = (id, season) =>
  useApi(`match?id=${id}&season=${season}`);
